var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "accordion cols" }, [
    _c(
      "div",
      {
        staticClass: "header collapsed",
        attrs: {
          id: _vm.triggerId,
          "data-toggle": "collapse",
          "data-target": _vm.collapseIdId,
          "aria-expanded": "false",
        },
      },
      [
        _c("div", { staticClass: "year" }, [_vm._v(_vm._s(_vm.item.acf.year))]),
        _vm._v(" "),
        _c("div", {
          staticClass: "title",
          domProps: { innerHTML: _vm._s(_vm.item.title.rendered) },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "content collapse",
        attrs: { id: _vm.collapseId, "aria-labelledby": _vm.triggerId },
      },
      [
        _c("div", { staticClass: "row no-gutters inner-wrapper" }, [
          _c("div", {
            staticClass: "text",
            domProps: { innerHTML: _vm._s(_vm.description) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "details" }, [
            _c("div", {
              staticClass: "program",
              domProps: { innerHTML: _vm._s(_vm.program) },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "author",
              domProps: { innerHTML: _vm._s(_vm.authors) },
            }),
            _vm._v(" "),
            _vm.linkUrl
              ? _c(
                  "a",
                  {
                    staticClass: "cta circle-cta blue",
                    attrs: { href: _vm.linkUrl, target: "_blank" },
                  },
                  [_vm._m(1), _vm._v(" "), _c("span", [_vm._v("Learn More")])]
                )
              : _vm._e(),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", {
        staticClass: "svg",
        attrs: {
          src: "/app/themes/ucla/resources/assets/images/chevron.svg",
          width: "16px",
          height: "16px",
          alt: "dropdown",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "sr-only" }, [_vm._v("dropdown")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", {
        staticClass: "svg",
        attrs: {
          src: "/app/themes/ucla/resources/assets/images/arrow.svg",
          width: "16px",
          height: "16px",
          alt: "Learn More",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "sr-only" }, [_vm._v("Learn More")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/ResearchAccordion.vue